import Modal from 'react-modal';
import { useRef, useState } from 'react';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';

import api from '../../services/api';
import Button from '../Button';
import Input from '../Input';
import Notification from '../Notification';
import UserSelect from '../UserSelect';

import { Headline, ButtonsContainer, modalStyles } from './styles';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const AddVoucherModal = ({ isOpen, onClose, onConfirm }) => {
  const formRef = useRef(null);

  const [isLoading, setLoading] = useState(false);
  // Fora do unform: o select é assíncrono e guarda a opção inteira (id, nome e
  // e-mail) para conseguir se redesenhar; ao formulário vai só o id.
  const [owner, setOwner] = useState(null);

  function handleClose() {
    setOwner(null);
    onClose();
  }

  async function handleSubmitForm(data) {
    try {
      setLoading(true);
      await api.post(`/admin/vouchers`, {
        ...data,
        ownerId: owner ? owner.value : null,
      });
      Notification({
        message: 'Voucher adicionado com sucesso',
        type: Notification.types.SUCCESS,
      });
      setOwner(null);
      onConfirm();
    } catch (err) {
      if (err.response) {
        Notification({
          message: err.response.data.error,
          type: Notification.types.ERROR,
        });
        if (err.response.data.errors) {
          formRef.current.setErrors(err.response.data.errors);
        }
      } else {
        Notification({
          message: 'Erro ao criar voucher',
          type: Notification.types.ERROR,
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Adicionar voucher"
      style={modalStyles}
      closeTimeoutMS={500}
    >
      {isLoading && <div className="loader" />}
      <Headline>Adicionar voucher</Headline>
      <Form onSubmit={handleSubmitForm} ref={formRef}>
        <Input type="number" label="Valor do voucher" name="value" />
        <Input
          type="number"
          label="Dias para expirar voucher"
          name="expiresAtDays"
        />
        <Input type="number" label="Nº máximo de usos" name="maxUses" />
        <UserSelect
          label="Proprietário (opcional)"
          value={owner}
          onChange={setOwner}
        />
        <ButtonsContainer>
          <Button text="Cancelar" onClick={handleClose} />
          <Button text="Confirmar" primary type="submit" />
        </ButtonsContainer>
      </Form>
    </Modal>
  );
};

AddVoucherModal.propTypes = propTypes;

export default AddVoucherModal;
